define('webshopLandingpagesDetailBodyTextsLanguageView',[
  'app',
  'module',
  'backbone',
  'marionette',
  'underscore',
  'settings',
  'selectView',
  'template!webshopLandingpagesDetailBodyTextsLanguageView'
], function (
  App,
  Module,
  Backbone,
  Marionette,
  _,
  Settings,
  SelectView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'language-view',

    ui: {
      name: '.item.name input',
      slug: '.item.slug input',          
      metaTitle: '.item.meta-title input',
      metaDescription: '.item.meta-description textarea'
    },

    events: {
      'change @ui.name': 'changeName',
      'change @ui.slug': 'changeSlug',      
      'change @ui.metaTitle': 'changeMetaTitle',
      'change @ui.metaDescription': 'changeMetaDescription'
    },

    serializeData: function () {
      var data = {};
      data.language = this.model.get('language');
      data.name = this.model.get('landingpage').getName(data.language);
      data.slug = this.model.get('landingpage').getSlug(data.language);     
      data.metaTitle = this.model.get('landingpage').getMetaTitle(data.language);
      data.metaDescription = this.model.get('landingpage').getMetaDescription(data.language);
      return data;
    },

    fetch: function () {
      this.model.get('landingpage').fetch().done(_.bind(function () {
        this.render();
      }, this));
    },

    changeName: function () {
      this.model.get('landingpage').setName(this.model.get('language'), this.ui.name.val())
      .always(_.bind(function () {
        this.fetch();
      }, this));
    },

    changeSlug: function () {
      this.model.get('landingpage').setSlug(this.model.get('language'), this.ui.slug.val())
      .always(_.bind(function () {
        this.fetch();
      }, this));
    },

    changeMetaTitle: function () {
      this.model.get('landingpage').setMetaTitle(this.model.get('language'), this.ui.metaTitle.val())
      .always(_.bind(function () {
        this.fetch();
      }, this));
    },

    changeMetaDescription: function () {
      this.model.get('landingpage').setMetaDescription(this.model.get('language'), this.ui.metaDescription.val())
      .always(_.bind(function () {
        this.fetch();
      }, this));
    }
  });
});
